export const music = [
  {
      name: "radio",
      description: "Play radio in voice channel",
      type: 1,
      options:[
          {
              name: "radio_number",
              description: "The number of radio to choose the radio station",
              type: 4,
              required: false
          }
      ]
  },
  {
      name: "autoplay",
      description: "Autoplay music (Random play songs)",
      type: 1
  },
  {
      name: "clear",
      description: "Clear song in queue!",
      type: 1
  },
  {
      name: "forward",
      description: "Forward timestamp in the song!",
      type: 1,
      options: [
          {
              name: "seconds",
              description: "The number of seconds to forward the timestamp by.",
              type: 4,
              required: false
          }
      ],
  },
  {
      name: "join",
      description: "Make the bot join the voice channel.",
      type: 1
  },
  {
      name: "leave",
      description: "Make the bot leave the voice channel.",
      type: 1
  },
  {
      name: "loop",
      description: "Loop song in queue type all/current!",
      type: 1,
      options: [
          {
              name: "type",
              description: "Type of loop",
              type: 3,
              required: true,
              choices: [
                  {
                      name: "Current",
                      value: "current"
                  },
                  {
                      name: "Queue",
                      value: "queue"
                  }
              ]
          }
      ],
  },
  {
      name: "loopall",
      description: "Loop all songs in queue!",
      type: 1
  },
  {
      name: "lyrics",
      description: "Display lyrics of a song.",
      type: 1,
      options: [
          {
              name: "input",
              description: "The song you want to find lyrics for",
              type: 3,
              required: false,
          }
      ],
  },
  {
      name: "nowplaying",
      description: "Display the song currently playing.",
      type: 1
  },
  {
      name: "pause",
      description: "Pause the music!",
      type: 1
  },
  {
      name: "play",
      description: "Play a song from any types.",
      type: 1,
      options: [
          {
              name: "input",
              description: "The input of the song",
              type: 3,
              required: true,
          }
      ], 
  },
  {
      name: "previous",
      description: "Play the previous song in the queue.",
      type: 1
  },
  {
      name: "queue",
      description: "Show the queue of songs.",
      type: 1,
      options: [
          {
              name: "page",
              description: "Page number to show.",
              type: 4,
              required: false,
          }
      ],
  },
  {
      name: "replay",
      description: "Replay the current song!",
      type: 1
  },
  {
      name: "resume",
      description: "Resume the music!",
      type: 1
  },
  {
      name: "rewind",
      description: "Rewind timestamp in the song!",
      type: 1,
      options: [
          {
              name: "seconds",
              description: "Rewind timestamp in the song!",
              type: 4,
              required: false,
          }
      ],
  },
  {
      name: "search",
      description: "Search for a song!",
      type: 1,
      options: [
          {
              name: "input",
              description: "The input of the song",
              type: 3,
              required: true,
          }
      ],
  },
  {
      name: "seek",
      description: "Seek timestamp in the song!",
      type: 1,
      options: [
          {
              name: "seconds",
              description: "The number of seconds to seek the timestamp by.",
              type: 4,
              required: true,
          }
      ],
  },
  {
      name: "shuffle",
      description: "Shuffle song in queue!",
      type: 1
  },
  {
      name: "skip",
      description: "Skips the song currently playing.",
      type: 1
  },
  {
      name: "skipto",
      description: "Skips to a certain song in the queue.",
      type: 1,
      options: [
          {
              name: "position",
              description: "The position of the song in the queue.",
              type: 4,
              required: true,
          }
      ],
  },
  {
      name: "volume",
      description: "Adjusts the volume of the bot.",
      type: 1,
      options: [
          {
              name: "amount",
              description: "The amount of volume to set the bot to.",
              type: 4,
              required: false,
          }
      ],
  },
  {
      name: "file-play",
      description: "Play the music file for the bot",
      type: 1,
      options: [
          {
              name: "input",
              description: "The music file to play",
              type: 11,
          }
      ]/// SUBCOMMAND! = 1
  },
]